import { isAxiosError } from './api/axios-error';

export type RootInitErrorType = 'tenant-not-found' | 'system-error';

const tenantNotFoundMessage = '企业不存在';

export function getRootInitErrorType(
  error: unknown,
): RootInitErrorType | undefined {
  if (error instanceof Error && error.message === tenantNotFoundMessage) {
    return 'tenant-not-found';
  }
  if (isAxiosError(error)) {
    const status = error.response?.status || 0;
    if (status >= 500) {
      return 'system-error';
    }
  }
}

export function createTenantNotFoundError() {
  return new Error(tenantNotFoundMessage);
}
